<template>
    <div>
        <div v-if="element.id == null">
            <add-new-category-form :element="element" @saveChildCategory="saveChildCategory"></add-new-category-form>
        </div>
        <div v-if="element.id != null">
            <edit-category-form  v-if="editMode" :element="element" @updateCategory="updateCategory"></edit-category-form>
            <div v-if="!editMode">
                <button @click="toggleChildren" v-show="hasChildren">[{{ showChildren ? '-' : '+' }}]</button>
                {{ element.name }}
                <button class="badge bg-info text-dark m-1" @click="addChildCategory">add new</button>
                <button class="badge bg-warning text-dark m-1" @click="activateCategoryMode">edit</button>
                <delete-child-category :element="element" @deleteCategory="deleteCategory"></delete-child-category>
            </div>
        </div>
    </div>

</template>

<script>

import AddNewCategoryForm from "./AddNewCategoryForm";
import EditCategoryForm from "./EditCategoryForm";
import DeleteChildCategory from "./DeleteChildCategory";
export default {

    name: "TreeItem",
    components: {
        AddNewCategoryForm,
        DeleteChildCategory,
        EditCategoryForm

    },
    props: {
        hasChildren: {

        },
        showChildren: {
            default: false,
        },
        element: {
            required: false,
            default: null,
        }
    },
    data() {
        return {
            //showChildren: false,
            editMode: false,
            form: new Form({name: 'test', sort_order: 0})
        };
    },
    methods: {
        activateCategoryMode() {
            this.editMode = true;
        },

        updateCategory(category) {
            this.editMode = false;
            this.$emit('updateCategory', category);
        },

        toggleChildren() {
            //this.showChildren = !this.showChildren;
            this.$emit('toggleChildren', this.element);
        },
        addChildCategory() {
            this.toggleChildren();
            this.$emit('addChildCategory', this.element);
        },
        deleteCategory() {
            this.$emit('deleteCategory', this.element);
        },
        saveChildCategory(category) {
            this.$emit('saveChildCategory', category);
        },
        onSubmit(){
            this.form.post('/categories').then(response => console.log(response))
        }
    }
}
</script>

<style scoped>

</style>
